import { Checkbox } from '@qodo/design-system';
import { SelectionCheckboxRowProps } from '../types';

export const SelectionCheckboxRow = ({
  name,
  label,
  checked,
  onCheckedChange,
  icon: Icon,
  ariaLabel,
  disabled,
}: SelectionCheckboxRowProps) => {
  return (
    <Checkbox
      name={name}
      checked={checked}
      onCheckedChange={onCheckedChange}
      wrapperClassName="p-0 gap-3"
      aria-label={ariaLabel}
      disabled={disabled}
      label={
        <div className="flex items-center gap-3 flex-1">
          <div className="shrink-0 [&>svg]:text-text-interactive-neutral-idle!">
            <Icon className="size-4" />
          </div>
          {label}
        </div>
      }
    />
  );
};
